function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff;stroke:#fff;stroke-width:.2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5850",
  "data-name": "Group 5850",
  transform: "translate(1545.745 637.599)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2734",
  "data-name": "Path 2734",
  className: "cls-2",
  d: "M12.135 1.953a.858.858 0 0 1 .858.858v1.412c1.677.469 4 1.8 4.237 5.563.084 1.3.084 3.364.36 5.268a7.091 7.091 0 0 0 1.037 2.7H3.88a7.1 7.1 0 0 0 1.036-2.7c.277-1.9.277-3.965.36-5.268.256-4.014 2.87-5.256 4.556-5.643V2.81a.857.857 0 0 1 .857-.858h1.447m0-1.558h-1.448A2.417 2.417 0 0 0 8.274 2.81V3a7.242 7.242 0 0 0-4.553 6.687c-.024.382-.042.828-.061 1.315a37.531 37.531 0 0 1-.286 3.828 5.559 5.559 0 0 1-.782 2.047 1.562 1.562 0 0 0 1.288 2.435h14.747a1.558 1.558 0 0 0 1.282-2.442 5.567 5.567 0 0 1-.777-2.04 37.8 37.8 0 0 1-.285-3.83 58.378 58.378 0 0 0-.061-1.315c-.252-3.952-2.425-5.744-4.235-6.553V2.81A2.418 2.418 0 0 0 12.135.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4310",
  "data-name": "Group 4310",
  transform: "translate(7.504 18.626)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2735",
  "data-name": "Path 2735",
  className: "cls-2",
  d: "M11.686 23.817A3.785 3.785 0 0 1 7.9 20.036h1.582a2.2 2.2 0 0 0 4.408 0h1.577a3.785 3.785 0 0 1-3.781 3.781z",
  transform: "translate(-7.904 -20.036)"
})));

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_7452",
    "data-name": "Group 7452",
    transform: "translate(-1534 -626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(1534 626)",
    style: {
      fill: "#ebf3f5",
      opacity: 0.25
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d1e63ed4.svg";
export { ForwardRef as ReactComponent };